let ol = require('openlayers');

class Geolocation {
    constructor() {
        this.locator = new ol.Geolocation({
            projection: "EPGS:3857"
        });
    }

    getPosition() {
        return this.locator.getPosition();
    }
}

module.exports = Geolocation;